import {
  Dialog,
  makeStyles,
  Slide,
  Grid,
  Button,  
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import * as DATANETAPI from "../DataNet/DataNet";
import * as COMS from "../../constants/comsTypes";
import * as CONF from "../../constants/conf";
import LoadingPage from "../LoadingPage";
import { red } from "@material-ui/core/colors";
import ButtonLoader from "../ButtonLoader";
import LanguageForm from './LanguageForm';
import AlertsForm from './AlertsForm';
import CommsForm from './CommsForm';
import GeneralForm from './GeneralForm';
import ProtocolForm from './ProtocolForm';
import MetronomeForm from './MetronomeForm';
import ShocksForm from "./ShocksForm";
import SaveConfDialog from './SaveConfDialog'
import DeviceSetupFormHeader from "./DeviceSetupFormHeader";
import DeviceSetupFromTitle from './DeviceSetupFormTitle'
import ErrorDialog from "../ErrorDialog";
const getProgramType = (item) =>
  item?.program_type ??
  item?.programType ??
  item?.programtype;

const isEmtProgramByType = (item) =>
  getProgramType(item)?.toString() === CONF.DEVICE_PROGRAM_TYPE_EMT?.toString();

const DeviceSetupForm = ({ open, handleClose, groupId, readOnly = false, isEmtProgram = false }) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const [groupData, setGroupData] = useState({});
  const [config, setConfig] = useState([]);
  const [isConfigLoaded, setIsConfigLoaded] = useState(false);
  const [isError, setIsError] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);
  const [confOptions, setConfOptions] = useState([]);
  const [isConfOptions, setIsConfOptions] = useState(false);
  const [listLangs, setListLangs] = useState([]);
  const [isFormChanged, setIsFormChanged] = useState(false);
  const [isFormValid, setIsFormValid] = useState(false);
  const [newVersion, setNewVersion] = useState([]);
  const [isNewVersion, setIsNewVersion] = useState(false);
  const [toUpdate, setToUpdate] = useState(false);
  const [openNotCompatible, setOpenNotCompatible] = useState(false);
  const [connectionErrorMsg, setConnectionErrorMsg] = useState("");
  const [isSaving, setIsSaving] = useState(false);
  const [errorLangs, setErrorLangs] = useState(false);
  const [errorAlerts, setErrorAlerts] = useState(false);
  const [errorComms, setErrorComms] = useState(false);
  const [errorGeneral, setErrorGeneral] = useState(false);
  const [errorProtocol, setErrorProtocol] = useState(false);
  const [errorMetronome, setErrorMetronome] = useState(false);
  const [errorShock, setErrorShock] = useState(false);
  const isCurrentEmtProgram = isEmtProgram || isEmtProgramByType(groupData);

  const resetForm = () => {
    handleClose(false);
    setOpenAlert(false);
    setIsError(false);
  };

  const updateConfig = (e) => {
    if (!isFormChanged && !toUpdate) {
      /**  si el formualio no se ha cambiado que no actualice nada */
      handleClose(false);
    } else {
      setIsSaving(true);
      e.preventDefault();
      if (newVersion?.version_current == "0100") {
        setOpenNotCompatible(true);
      } else {
        if (groupId !== undefined) {
          var conf_update = {
            new_update: toUpdate && newVersion !== null,
            new_version: "",
            old_version: "",
            opt_version: "",
            config: config,
          };

          if (toUpdate && newVersion !== null) {
            conf_update.new_version = newVersion?.version_new;
            conf_update.old_version = newVersion?.version_current;
            conf_update.opt_version = newVersion?.opt_version;
          }
          /* comprobar que los parametros en standalone van a 0 en las comunicaciones */
          if (groupData?.comsTypes?.includes(COMS.STANDALONE) && !!conf_update?.config?.device_setting?.misc?.transmission_mode) {
            conf_update.config.device_setting.misc.transmission_mode = { priority: 0, gps_enable: 0, transmit_frequency: 0 };
          }
          // console.log("datos que se van a subir", conf_update.config.device_setting.misc.transmission_mode);
          DATANETAPI.editConfig(conf_update, groupId).then((snap) => {
            if (snap.status < 0) {
              setConnectionErrorMsg(t(`error.connection_${snap.status}`));
              setIsSaving(false);
            } else {
              if (snap != undefined) {
                setIsSaving(false);
                setOpenAlert(true);
                if (snap.status === 1) {
                  setIsError(false);
                  requestVersionUpdate();
                } else {
                  setIsError(true);
                }
              }
            }
          });
        } else {
          setIsError(true);
          setIsSaving(false);
        }
      }
    }
  };

  useEffect(() => {
    /** revisar cuando se actualiza el formulario para salir sin hacer la petición */
    if (!isFormChanged && isConfigLoaded && isConfOptions) {
      setIsFormChanged(true);
    }
  }, [config, listLangs, confOptions]);

  useEffect(() => {
    if (!open || groupId === undefined) {
      return;
    }

    DATANETAPI.getGroup(groupId).then((snap) => {
      var backendGroups = snap.data;
      if (backendGroups !== undefined) {
        setGroupData(backendGroups);

        if (
          backendGroups?.config_current?.device_setting?.langs?.combination === "en-fr-de-es-it-pl" ||
          backendGroups?.config_current?.device_setting?.langs?.combination === "en-fr-de-es-lt-pl"
        ) {
          backendGroups.config_current.device_setting.langs.combination = "en-fr-de-el-lt-pl";
          backendGroups.config_current.device_setting.langs.list = ["02_EN", "03_FR", "10_DE", "13_EL", "12_LT", "11_PL"];
          backendGroups.config_current.device_setting.langs.default_lang = 1;
        }

        setListLangs(backendGroups?.config_current?.device_setting?.langs?.list);
        setConfig(backendGroups?.config_current);
        setIsConfigLoaded(true);
      } else {
        setConfig([]);
        setIsConfigLoaded(true);
      }
    });

    DATANETAPI.getConfOptions(groupId).then((snap) => {
      if (snap?.status < 0) {
        setConnectionErrorMsg(t(`error.connection_${snap?.status}`));
        setListLangs([]);
        setConfOptions([]);
        setIsConfOptions(false);
      } else {
        if (snap.data !== undefined) {
          var lang_combinations = snap?.data?.combinations.map((x) => {
            if (x.name === "en-fr-de-es-it-pl") {
              x.name = "en-fr-de-el-lt-pl";
              x.list = ["02_EN", "03_FR", "10_DE", "13_EL", "12_LT", "11_PL"];
            }
            return x;
          });

          lang_combinations = lang_combinations?.filter((x, i, self) => {
            return lang_combinations?.findIndex((xi) => xi?.name === x?.name) === i;
          });

          snap.data.combinations = lang_combinations;
          setConfOptions(snap.data);
          setIsConfOptions(true);
        } else {
          setListLangs([]);
          setConfOptions([]);
          setIsConfOptions(false);
        }
      }
    });

    requestVersionUpdate();
  }, [open, groupId]);

  const requestVersionUpdate = () => {
    DATANETAPI.newVersionGroup(groupId).then((snap) => {
      if (snap?.status < 0) {
        setConnectionErrorMsg(t(`error.connection_${snap.status}`));
        setIsNewVersion(false);
        setNewVersion([]);
      } else {
        if (snap.status === 1) {
          setNewVersion(snap.data);
          setIsNewVersion(true);
        } else {
          setIsNewVersion(false);
          setNewVersion([]);
        }
      }
    });
  };

  useEffect(() => {
    if (isConfigLoaded) {
      let error = false;
      error = config?.device_setting?.shocks?.energy2_adult < config?.device_setting?.shocks?.energy1_adult ? true : error;
      error = config?.device_setting?.shocks?.energy3_adult < config?.device_setting?.shocks?.energy2_adult ? true : error;
      error = config?.device_setting?.shocks?.energy3_pediatric < config?.device_setting?.shocks?.energy2_pediatric ? true : error;
      error = config?.device_setting?.shocks?.energy3_pediatric < config?.device_setting?.shocks?.energy2_pediatric ? true : error;
      setIsFormValid(!error && !errorLangs);
    }
  }, [config, toUpdate, errorLangs]);

  return (
    <Dialog fullScreen open={open} TransitionComponent={Transition}>
      <DeviceSetupFormHeader style={classes} groupData={groupData} handleClose={handleClose}/>
      {(!isConfigLoaded || !isConfOptions || !isNewVersion) && <LoadingPage />}

      {isConfigLoaded && isConfOptions && isNewVersion && (
        <Grid item xs={12} container justify="center" alignItems="flex-start" style={{ marginTop: 32 }}>
          <Grid container spacing={3} item xs={12} lg={10} xl={8}>
          
            <DeviceSetupFromTitle 
              isNewVersion={isNewVersion} newVersion={newVersion} 
              groupData={groupData} toUpdate={toUpdate} setToUpdate={setToUpdate}
              config={config} setConfig={setConfig}
              isEmtProgram={isCurrentEmtProgram}
            />

            <LanguageForm 
              config={config} setConfig={setConfig} confOptions={confOptions} 
              listLangs={listLangs} setListLangs={setListLangs}
              errorLangs={errorLangs} setErrorLangs={setErrorLangs}
              readOnly={readOnly}
              isEmtProgram={isCurrentEmtProgram}
            />
            
            <GeneralForm
              version={parseInt(newVersion?.version_current)}
              config={config} setConfig={setConfig}
              errorGeneral={errorGeneral} setErrorGeneral={setErrorGeneral} />

            <CommsForm 
              version={parseInt(newVersion?.version_current)}
              config={config} setConfig={setConfig}
              errorComms={errorComms} setErrorComms={setErrorComms} 
              groupData={groupData} />

            <AlertsForm 
              version={parseInt(newVersion?.version_current)}
              config={config} setConfig={setConfig}
              errorAlerts={errorAlerts} setErrorAlerts={setErrorAlerts}  />

            <ProtocolForm 
              config={config} setConfig={setConfig}
              errorAlerts={errorProtocol} setErrorAlerts={setErrorProtocol}  />

            <MetronomeForm 
              config={config} setConfig={setConfig}
              errorAlerts={errorMetronome} setErrorAlerts={setErrorMetronome}  />
            
            <ShocksForm 
              config={config} setConfig={setConfig}
              errorShock={errorShock} setErrorAlerts={setErrorShock}  />

            <SaveConfDialog
              isError={isError} openAlert={openAlert} setOpenAlert={setOpenAlert}
              resetForm={resetForm} connectionErrorMsg={connectionErrorMsg} setConnectionErrorMsg={setConnectionErrorMsg}
              openNotCompatible={openNotCompatible} setOpenNotCompatible={setConnectionErrorMsg} />

            <Grid container item xs={12} justify="flex-end" style={{ marginBottom: 34 }}>
              <Button variant="text" style={{ color: red[500] }} className={classes.closeButton} onClick={resetForm}>
                {t("common.close")}
              </Button>
              <Button variant="contained" color="primary" disabled={!isFormValid || isSaving} onClick={updateConfig}>
                {isSaving && <ButtonLoader />}
                {toUpdate ? t("common.update") : t("common.ok")}
              </Button>
            </Grid>
          </Grid>
        </Grid> )}
    </Dialog>
  );
};

export default DeviceSetupForm;

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  appBar: {
    position: "relative",
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
  root: {
    width: "100%",
  },
  closeButton: {
    marginRight: theme.spacing(2),
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  formcontainer: {
    padding: 24,
  },
  formControl: {
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});


